import { ActionTree, ActionContext } from 'vuex';
import { EnquiryApi } from '@/api/enquiry-api';
import { EnquiryFilters } from '@/models/enquiry-filters';
import { Mutations } from '@/stores/enquiries/mutation-constants';
import { State } from '@/stores/enquiries/state';
import { Forbidden } from '@/models/forbidden-error';
import router from '@/router';
import { NotFound } from '@/models/not-found-error';

const api = new EnquiryApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>, filters: EnquiryFilters) => {
        try {
            const result = await api.fetchAsync(filters);
            context.commit(Mutations.SetAllEnquiries, result.enquiries);
            // context.commit(Mutations.SetCurrentPageSize, result.pageSize);
            context.commit(Mutations.SetAllEnquiriesTotalPages, Math.ceil(result.total / ((result.pageSize < 1) ? 1 : result.pageSize)));
            context.commit(Mutations.SetAllEnquiriesTotalEnquiries, result.total);
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }

    public fetchForUserAsync = async (context: ActionContext<State, any>, payload: { userId: number, filters: EnquiryFilters }) => {
        try {
            const result = await api.fetchForUserAsync(payload.userId, payload.filters);
            context.commit(Mutations.SetMyEnquiries, result.enquiries);
            // context.commit(Mutations.SetCurrentPageSize, result.pageSize);
            context.commit(Mutations.SetMyEnquiriesTotalPages, Math.ceil(result.total / ((result.pageSize < 1) ? 1 : result.pageSize)));
            context.commit(Mutations.SetMyEnquiriesTotalEnquiries, result.total);
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }
    public updateMyEnquiriesKeyword = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetMyEnquiriesKeyword, value);
    }
    public updateMyEnquiriesFilterStatus = (context: ActionContext<State, any>, value: number | string | null) => {
        context.commit(Mutations.SetMyEnquiriesFilterStatus, value);
    }
    public updateMyEnquiriesPage = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetMyEnquiriesPage, value);
    }
    public updateMyEnquiriesPageSize = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetMyEnquiriesPageSize, value);
    }
    public updateMyEnquiriesFrom = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetMyEnquiriesFrom, value);
    }
    public updateMyEnquiriesTo = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetMyEnquiriesTo, value);
    }
    public updateAllEnquiriesKeyword = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetAllEnquiriesKeyword, value);
    }
    public updateAllEnquiriesFilterStatus = (context: ActionContext<State, any>, value: number | string | null) => {
        context.commit(Mutations.SetAllEnquiriesFilterStatus, value);
    }
    public updateAllEnquiriesPage = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetAllEnquiriesPage, value);
    }
    public updateAllEnquiriesPageSize = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetAllEnquiriesPageSize, value);
    }
    public updateAllEnquiriesFrom = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetAllEnquiriesFrom, value);
    }
    public updateAllEnquiriesTo = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetAllEnquiriesTo, value);
    }
}
